// Core
import { ParameterValues } from '../../../core/resources';

// Interfaces
import { IAnimalAnnouncementBatch } from '../../../interfaces/IAnnouncement';

export const mapParameters = (parameters: ParameterValues) => {
    return parameters.map((parameter) => ({
        text: parameter.text,
        value: parameter.code,
    }));
};

export const isAnimalsAndSalesType = (row: IAnimalAnnouncementBatch) => {
    if (
        row.Animals[0] !== undefined &&
        row.Animals[0].SalesType !== null &&
        row.Animals[0].SalesType !== undefined
    )
        return true;
    return false;
};
